import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"basic\"><a href=\"#basic\"></a> Basic Example </h1><div class=\"py-5\"> Use <code>.overlay</code> on an element and wrap the element&#39;s primary content with <code>.overlay-wrapper</code> and the overlay content with <code>.overlay-layer</code> and set the overlay backgroud color with opacity with <code>.bg-white .bg-opacity-5</code>: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"card overlay\"><div class=\"card-body p-0\"><div class=\"overlay-wrapper\"><img src=\"media/stock/600x400/img-1.jpg\" alt=\"\" class=\"w-100 rounded\"></div><div class=\"overlay-layer bg-dark bg-opacity-10\"><a href=\"#\" class=\"btn btn-primary btn-shadow\">Explore</a><a href=\"#\" class=\"btn btn-light-primary btn-shadow ms-2\">Purchase</a></div></div></div></div><div class=\"col-lg-4\"><div class=\"card overlay\"><div class=\"card-body p-0\"><div class=\"overlay-wrapper\"><img src=\"media/stock/600x400/img-2.jpg\" alt=\"\" class=\"w-100 rounded\"></div><div class=\"overlay-layer bg-dark bg-opacity-10 align-items-end justify-content-center\"><div class=\"d-flex flex-grow-1 flex-center py-5\"><a href=\"#\" class=\"btn btn-primary btn-shadow\">Explore</a><a href=\"#\" class=\"btn btn-light-primary btn-shadow ms-2\">Purchase</a></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"card overlay\"><div class=\"card-body p-0\"><div class=\"overlay-wrapper\"><img src=\"media/stock/600x400/img-3.jpg\" alt=\"\" class=\"w-100 rounded\"></div><div class=\"overlay-layer bg-dark bg-opacity-10 align-items-start justify-content-center\"><div class=\"d-flex flex-grow-1 flex-center py-5\"><a href=\"#\" class=\"btn btn-primary btn-shadow\">Explore</a><a href=\"#\" class=\"btn btn-light-primary btn-shadow ms-2\">Purchase</a></div></div></div></div></div></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="row">
          <div class="col-lg-4">
            <!--begin::Card-->
            <div class="card overlay">
              <div class="card-body p-0">
                <div class="overlay-wrapper">
                  <img
                    src="assets/media/stock/600x400/img-1.jpg"
                    alt=""
                    class="w-100 rounded"
                  />
                </div>
                <div class="overlay-layer bg-dark bg-opacity-10">
                  <a href="#" class="btn btn-primary btn-shadow">Explore</a>
                  <a href="#" class="btn btn-light-primary btn-shadow ms-2"
                    >Purchase</a
                  >
                </div>
              </div>
            </div>
            <!--end::Card-->
          </div>

          <div class="col-lg-4">
            <!--begin::Card-->
            <div class="card overlay">
              <div class="card-body p-0">
                <div class="overlay-wrapper">
                  <img
                    src="assets/media/stock/600x400/img-2.jpg"
                    alt=""
                    class="w-100 rounded"
                  />
                </div>
                <div
                  class="overlay-layer bg-dark bg-opacity-10 align-items-end justify-content-center"
                >
                  <div class="d-flex flex-grow-1 flex-center py-5">
                    <a href="#" class="btn btn-primary btn-shadow">Explore</a>
                    <a href="#" class="btn btn-light-primary btn-shadow ms-2"
                      >Purchase</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!--end::Card-->
          </div>

          <div class="col-lg-4">
            <!--begin::Card-->
            <div class="card overlay">
              <div class="card-body p-0">
                <div class="overlay-wrapper">
                  <img
                    src="assets/media/stock/600x400/img-3.jpg"
                    alt=""
                    class="w-100 rounded"
                  />
                </div>
                <div
                  class="overlay-layer bg-dark bg-opacity-10 align-items-start justify-content-center"
                >
                  <div class="d-flex flex-grow-1 flex-center py-5">
                    <a href="#" class="btn btn-primary btn-shadow">Explore</a>
                    <a href="#" class="btn btn-light-primary btn-shadow ms-2"
                      >Purchase</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!--end::Card-->
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}